import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import colors from '@constants/colors'
import urlUtils from '@services/urlUtils'
import { useHistory } from 'react-router-dom'
import {
    useDanceOnAddProcess,
    useSaveFromReAkumSearch,
} from '@state/uses/dances'
import { setDanceOnAddProcess } from '@state/actions/dances'
import AcumSongsTable from '@components/AcumSearch/AcumSongsTable'
import SubmitButton from '@components/Buttons/SubmitButton'
import {
    MainPageWrapper,
    TextBtn,
    PageHeader,
    PageSubTitle,
    SubmitBtnContainer,
    Flex1,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { song } = urlUtils.getQueryParams() || {}
    const danceOnAddProcess = useDanceOnAddProcess()
    const [term, setTerm] = useState(null)
    const saveFromReAkumSearch = useSaveFromReAkumSearch()

    useEffect(() => {
        if (song) {
            setTerm(song)
        }
    }, [song])

    useEffect(() => {
        if (!danceOnAddProcess) {
            history.push('dance')
        }
    }, [])

    const onSongNotFound = () => {
        danceOnAddProcess.song = Object.assign({}, danceOnAddProcess.song, {
            akum_id: 'not_found',
        })
        dispatch(setDanceOnAddProcess(danceOnAddProcess))
        history.push({
            pathname: 'dance',
        })
    }

    const backToAddDance = () => {
        danceOnAddProcess?.id
            ? history.push({
                  pathname: '/dance',
                  search: danceOnAddProcess.id,
              })
            : history.push({
                  pathname: '/dance',
              })
    }

    return (
        <MainPageWrapper>
            <PageHeaderRow>
                <BackButtonContainer>
                    <SubmitButton
                        label={i18n.t('akum_results_table.back_to_add_dance')}
                        backgroundColor={colors.BACK_BUTTON}
                        onClick={backToAddDance}
                    />
                </BackButtonContainer>
                <PageHeader>
                    {i18n.t('akum_results_table.search_of_song')} -{' '}
                    {danceOnAddProcess?.name} -{' '}
                    {i18n.t('akum_results_table.in_the_database_of')}
                </PageHeader>
                <Flex1 />
            </PageHeaderRow>
            {!saveFromReAkumSearch && (
                <PageSubTitle>
                    {i18n.t('akum_results_table.cant_find_the_song')}
                    <TextBtn onClick={onSongNotFound}>
                        {i18n.t('akum_results_table.click_here')}
                    </TextBtn>
                    {i18n.t('akum_results_table.fill_song_manualy')}
                </PageSubTitle>
            )}

            {term && <AcumSongsTable term={term} />}
        </MainPageWrapper>
    )
}

const PageHeaderRow = styled.div`
    display: flex;
    width: 100%;
    @media (max-width: 1000px) {
        display: initial;
    }
`

const BackButtonContainer = styled(SubmitBtnContainer)`
    padding: 0px 20px;
    justify-content: flex-start;
`
